import "../../CommonImports";
import "../../Core/core.css";
import "./List.css";
import "./ListDropIndicator.css";
import * as React from "react";
import { css } from '../../Util';
export function ListDropIndicator(props) {
    var position = props.position, xOffset = props.xOffset;
    var left = (xOffset || 0) + "px";
    var positionClassName = position === 1 /* top */ ? "top" : "bottom";
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css("bolt-list-drop-indicator-line flex-grow absolute", positionClassName), style: { left: left } }),
        React.createElement("div", { className: css("bolt-list-drop-indicator-circle absolute", positionClassName), style: { left: left } })));
}
